import React from 'react';
import { DropdownSubMenuItemProps } from "./props.type"
import * as styles from './dropdown.module.sass'
import { Size } from "../../enums/size"
import classNames from "classnames"
import { useTranslation } from "../../../i18n/use-translation"
import { Icon } from "../../atoms/icon"

export const DropdownSubMenuItem = (props: DropdownSubMenuItemProps) => {
  const { t, locale } = useTranslation();
  
    return (
        <a  className={classNames(styles.cabinet_item, props.className)} href={`/${locale}/${props.route}`}>
            <Icon size={Size.MEDIUM} className={classNames(`icon-${props.icon}`, styles.material_icons)} />
            {t(props.title)}
        </a>
    )
}